import React from 'react';
import { useSelector } from 'react-redux';
// modals
import { organizationModals } from 'src/organizations/components/modals';
import { dispatchingModals } from 'src/dispatching/components/modals';
import { safetyModals } from 'src/safety/components/modals';
import { orderModals } from 'src/orders/components/modals';
import { pricingModals } from 'src/pricing/components/modals';
import { warehouseModals } from 'src/warehouse/components/modals';

const modalComponentsByType = {
  ...organizationModals,
  ...dispatchingModals,
  ...safetyModals,
  ...orderModals,
  ...pricingModals,
  ...warehouseModals,
};

const ModalContainer = () => {
  const { type, modal, props } = useSelector(({ modal }) => modal);
  if (!type && !modal) {
    return null;
  }
  const Modal = modal || modalComponentsByType[type];
  return <Modal {...props} />;
};

export default ModalContainer;
